/* eslint-disable */
import axios from '@/axios.js';

export const helloDnaProfileApi = {
  getHelloDnaProfiles(payload) {
    return axios.get('admin/dna/user-profiles', {
      params: payload,
    });
  },
  getHelloDnaProfile(id) {
    return axios.get(`admin/dna/user-profiles/${id}?join=tracking`);
  },
  updateHelloDnaProfile(id, body) {
    return axios.patch(`admin/dna/user-profiles/${id}`, body);
  },
  batchUpdateHelloDnaProfile(body) {
    return axios.post('admin/dna/user-profiles/status/received', body);
  },
  uploadHelloDnaReport(id, body) {
    return axios.post(`/admin/dna/user-profiles/${id}/report-upload`, body);
  },
};
